import { useLocalStorage } from 'react-use'

export type UseToggleSidebar = {
  show: boolean
  toggle: () => void
  showClassName: string
}

export const useToggleSidebar = (): UseToggleSidebar => {
  //we should get the value from the local storage
  const [show, setShow] = useLocalStorage('HIDE_MENU', false)

  const showClassName: string = show === true ? 'toggle-sidebar' : ''

  return {
    show,
    toggle: () => {
      setShow(!show)
    },
    showClassName,
  }
}
